import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getComplaintmentByAdvertReasons, getComplaintUserReasones} from "./Services";

export const useGetComplaintReasones = () => {

  const query = useQuery(
    [endpoints.getComplaintUserReasones],
    () => {
      return getComplaintUserReasones();
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};

export const useGetComplaintReasonesByAdvert = () => {

  const query = useQuery(
    [endpoints.getComplaintmentByAdvertReasons],
    () => {
      return getComplaintmentByAdvertReasons();
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};


